import { render, staticRenderFns } from "./ResourceMatrixView.vue?vue&type=template&id=94d75384"
import script from "./ResourceMatrixView.vue?vue&type=script&lang=js"
export * from "./ResourceMatrixView.vue?vue&type=script&lang=js"
import style0 from "./ResourceMatrixView.vue?vue&type=style&index=0&id=94d75384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports